
let index = 0;

export default function () {
	index++;
	return Date.now().toString(36) + '_' + index;
}
